// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

.userPermission {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f9f9f9;
  gap: 14px;
  height: 100vh;
  justify-content: space-between;
}

.footerImage {
  width: 100%;
}

.userPermission__userPermissiontring {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--header-FontWeight);
  font-size: var(--sub-header-FontSize);
  line-height: 32px;
  color: var(--button-color);
  padding-top: 14px;
}

.userPermission__footerImage {
  bottom: 0px;
  position: fixed;
  width: 100%;
}

.userPermission__pageImageGroup {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f9f9f9;
  gap: 14px;
  justify-content: space-between;
  padding-top: 105px;
  position: relative;
  z-index: 2011;
}

.userPermission__image404 {
  padding-top: 151px;
}

.userPermission__backButton {
  padding-top: 10px;
}

.userPermission .button.MuiButton-root,
.userPermission .button.MuiButton-root {
  border-radius: 4px;
  width: 147px;
  height: 42px;
  z-index: 3;
}

.userPermission__userPermissioninsuffstring {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--header-FontWeight);
  font-size: var(--sub-header-FontSize);
  line-height: 32px;
  position: relative;
  z-index: 1;
}

.userPermission__userPermissionaccount {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--default-FontWeight);
  font-size: var(--sub-header-FontSize);
  line-height: 32px;
  position: relative;
  z-index: 1;
}

img.imageavator {
  height: 70px;
}

img.marstonGroupImage {
  width: 18.229vw;
}

img.Image404 {
  width: 30.885vw;
}

@media screen and (min-width: 400px) and (max-width: 1100px) {
  .pageNotFound__pageImageGroup {
    padding-top: 60px;
  }

  img.imageavator {
    height: 60px;
  }

  .userPermission__image404 {
    padding-top: 86px;
  }
}

@media screen and (min-width: 1300px) and (max-width: 1380px) {
  .pageNotFound__pageImageGroup {
    padding-top: 30px;
  }

  img.imageavator {
    height: 60px;
  }

  .userPermission__image404 {
    padding-top: 100px;
  }
}

@media screen and (min-width: 1400px) and (max-width: 1700px) {
  .userPermission__image404 {
    padding-top: 95px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/userPermission/UserPermission.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;EACtC,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n.userPermission {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #f9f9f9;\n  gap: 14px;\n  height: 100vh;\n  justify-content: space-between;\n}\n\n.footerImage {\n  width: 100%;\n}\n\n.userPermission__userPermissiontring {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--header-FontWeight);\n  font-size: var(--sub-header-FontSize);\n  line-height: 32px;\n  color: var(--button-color);\n  padding-top: 14px;\n}\n\n.userPermission__footerImage {\n  bottom: 0px;\n  position: fixed;\n  width: 100%;\n}\n\n.userPermission__pageImageGroup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #f9f9f9;\n  gap: 14px;\n  justify-content: space-between;\n  padding-top: 105px;\n  position: relative;\n  z-index: 2011;\n}\n\n.userPermission__image404 {\n  padding-top: 151px;\n}\n\n.userPermission__backButton {\n  padding-top: 10px;\n}\n\n.userPermission .button.MuiButton-root,\n.userPermission .button.MuiButton-root {\n  border-radius: 4px;\n  width: 147px;\n  height: 42px;\n  z-index: 3;\n}\n\n.userPermission__userPermissioninsuffstring {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--header-FontWeight);\n  font-size: var(--sub-header-FontSize);\n  line-height: 32px;\n  position: relative;\n  z-index: 1;\n}\n\n.userPermission__userPermissionaccount {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--default-FontWeight);\n  font-size: var(--sub-header-FontSize);\n  line-height: 32px;\n  position: relative;\n  z-index: 1;\n}\n\nimg.imageavator {\n  height: 70px;\n}\n\nimg.marstonGroupImage {\n  width: 18.229vw;\n}\n\nimg.Image404 {\n  width: 30.885vw;\n}\n\n@media screen and (min-width: 400px) and (max-width: 1100px) {\n  .pageNotFound__pageImageGroup {\n    padding-top: 60px;\n  }\n\n  img.imageavator {\n    height: 60px;\n  }\n\n  .userPermission__image404 {\n    padding-top: 86px;\n  }\n}\n\n@media screen and (min-width: 1300px) and (max-width: 1380px) {\n  .pageNotFound__pageImageGroup {\n    padding-top: 30px;\n  }\n\n  img.imageavator {\n    height: 60px;\n  }\n\n  .userPermission__image404 {\n    padding-top: 100px;\n  }\n}\n\n@media screen and (min-width: 1400px) and (max-width: 1700px) {\n  .userPermission__image404 {\n    padding-top: 95px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
